/**
 * yd-promise-scroll: 交付信任段自动播放手风琴。无外部库。
 * 源自 web-hand-off promise-scroll.js：删 partials:loaded，补 shopify:section:load。
 * 监听 [data-promise]（须加在 .promise__list 上）；进视口后逐拍 3s 展开 .promise__item。
 * 尊重 reduced-motion（全展开）。幂等；只播一次。
 */
(function () {
  var STEP = 3000;
  function setup(list) {
    if (list.dataset.promiseReady) return;
    list.dataset.promiseReady = '1';
    var items = [].slice.call(list.querySelectorAll('.promise__item'));
    if (!items.length) return;
    var reduce = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    function play() {
      if (list.dataset.played) return;
      list.dataset.played = '1';
      if (reduce) { items.forEach(function (it) { it.classList.add('is-active'); }); return; }
      items[0].classList.add('is-active');
      var i = 1;
      var timer = setInterval(function () {
        if (i >= items.length) { clearInterval(timer); return; }
        items[i].classList.add('is-active');
        i += 1;
      }, STEP);
    }
    if ('IntersectionObserver' in window) {
      var io = new IntersectionObserver(function (entries) {
        entries.forEach(function (e) { if (e.isIntersecting) { play(); io.unobserve(e.target); } });
      }, { threshold: 0.4 });
      io.observe(list);
    } else { play(); }
  }
  function init() { document.querySelectorAll('[data-promise]').forEach(setup); }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init); else init();
  document.addEventListener('shopify:section:load', init);
  window.addEventListener('load', init);
})();
